import React, { useEffect, useState } from 'react'
import ContentService from '../../services/ContentService';
import { useParams } from 'react-router-dom';
import PageTitle from '../pagetitle/PageTitle';
import CustomContent from '../customContent/CustomContent';

export default function Content()
{
    const { uri } = useParams();
    const [content, setContent] = useState({});

    const getContent = () =>
    {
        const contentService = new ContentService();
        contentService.getOneContentWithCategory(uri)
            .then(resp => setContent(resp))
    }

    useEffect(() =>
    {
        getContent();
    }, []);

    return (
        <>
            <PageTitle name={content?.title}></PageTitle>

            <div class="container">
                <div class="singlePost my-4">
                    <CustomContent content={content} />
                </div>
            </div>
        </>
    )
}
